'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _iview = require('iview');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    map: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isMiddle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false,
      loadiing: this.loading
    };
  },

  computed: {
    width: function width() {
      return this.map[this.size];
    }
  },
  watch: {
    value: function value(newVal) {
      var _this = this;

      this.$nextTick(function () {
        _this.showModal = newVal;
        !newVal && _this.removeHidden();
        newVal && _this.addUitClass();
      });
    }
  },
  created: function created() {
    var defaultMap = {
      large: '768',
      small: '416'
    };
    this.map = (0, _assign2.default)(this.map, defaultMap);
  },
  render: function render(c) {
    var _this2 = this;

    return this.value ? c('div', {}, [c(_iview.Modal, {
      props: {
        value: this.showModal,
        width: this.width,
        maskClosable: false,
        loading: this.loadiing
      },
      attrs: (0, _extends3.default)({}, this.$attrs),
      ref: 'customModal',
      class: {
        'iv-custom-modal': true,
        'iv-middle': this.isMiddle
      },
      scopedSlots: (0, _extends3.default)({
        default: function _default(props) {
          return c('div', _this2.$slots.default);
        }
      }, this.$slots.header ? {
        header: function header(props) {
          return c('div', _this2.$slots.header);
        }
      } : {}, this.$slots.footer ? {
        footer: function footer(props) {
          return c('div', _this2.$slots.footer);
        }
      } : {}),
      on: {
        input: function input(event) {
          _this2.showModal = false;
          _this2.removeHidden();
          _this2.$emit('input', event);
        },
        'on-ok': function onOk() {
          _this2.loadiing = false;
          _this2.$emit('on-ok');
          _this2.$nextTick(function () {
            _this2.loadiing = true;
          });
        },
        'on-cancel': function onCancel() {
          _this2.$emit('on-cancel');
        },
        'on-visible-change': function onVisibleChange(res) {
          return _this2.$emit('on-visible-change', res);
        }
      }
    }, [this.$slots.header ? c('div', {
      slot: 'header'
    }, this.$slots.header) : ''])]) : c('');
  },

  methods: {
    close: function close() {
      this.$refs.customModal.visible = false;
      this.$emit('input', false);
      this.showModal = false;
      this.removeHidden();
    },
    removeHidden: function removeHidden() {
      var ishidden = document.body.style.overflow === 'hidden';
      ishidden && (document.body.style.overflow = 'initial');
    },
    addUitClass: function addUitClass() {
      //无法装饰者模式修改，只能使用原生侵入式修改DOM
      var footerEl = document.querySelector('.iv-custom-modal .ivu-modal-footer');
      if (!footerEl) return;
      footerEl.children[0] && footerEl.children[0].classList.add('iv-custom-modal-cancel');
      footerEl.children[1] && footerEl.children[1].classList.add('iv-custom-modal-save');
    }
  }
};